import React, { memo } from "react";
import Select from "react-select";

const CustomSelect = ({
  options = [],
  value = null,
  onChange,
  placeholder = "Select...",
  isClearable = false,
  isDisabled = false,
  isMulti = false,
  styles = {},
  className = "",
  ...props
}) => {
  const defaultStyles = {
    control: (base) => ({
      ...base,
      borderColor: "var(--font_default_color)",
      "&:hover": { borderColor: "var(--blue-color)" },
      boxShadow: "none",
    }),

    option: (base, state) => ({
      ...base,
      color: "var(--font_default_color)",
      backgroundColor: state.isFocused ? "var(--blue-color)" : "var(--font_default_color)",
      cursor: "pointer",
    }),
    singleValue: (base) => ({
      ...base,
      color: "var(--font_default_color)", // Change the font color of the selected value
    }),
  };

  return (
    <Select
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      isClearable={isClearable}
      isDisabled={isDisabled}
      isMulti={isMulti}
      classNamePrefix="custom-select"
      className={className}
      styles={{ ...defaultStyles, ...styles }}
      {...props}
      isSearchable={false}
      //  menuIsOpen={true}
    />
  );
};

export default memo(CustomSelect);
